<template>
    <!-- Settings View -->
    <div class="page-layout blank contacts-manage">
        <!-- <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                </div>
            </div>
        </div> -->
        <div class="pb-10" v-if="!ajaxCallinprogress">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="breadcrumbactive ml-3">
                    <div>
                        <span>Settings</span>

                        <a class="text-capitalize"  v-if="contacts == true">contacts</a>

                        <a class="text-capitalize " v-if="sales == true"><span class="pl-2" @click="goBack()">Sales</span></a>
                        <a class="text-capitalize" v-if="deals_active == true">Deals</a>
                        <a class="text-capitalize" v-if="leads_active == true">Leads</a>
                        <a class="text-capitalize" v-if="customer_active == true">Customer</a>
                        <a class="text-capitalize" v-if="territory_active == true">Territory</a>
                        <a class="text-capitalize" v-if="reminder_active == true">Reminders</a>
                        <a class="text-capitalize" v-if="products == true">products</a>
                        <a class="text-capitalize" v-if="access_mgmt == true">Tools</a>
                        <!-- <a class="text-capitalize" v-if="access_mgmt == true">access_mgmt</a> -->

                    </div>
                </div>
                <div class="infoHeader px-3 py-1" style="background: transparent;">
                    <div class="descriptionheader p-0">
                        <div class="description-text-header-left">
                        </div>

                        <div class="description-text-header-right" v-if="activateEditMode">
                            <button class="btn btn-new-danger btn-smm ml-3" style="box-shadow: none !important;min-width: 5rem;" @click="hideSettingsEdit">CANCEL</button>
                            <button type="button" @click="updateSettings" class="btn btn-new-green btn-smm ml-3" style="box-shadow: none;">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-block pl-2 pr-1">
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block" style="border-radius: 15px;">
                    <el-container class="outlet-details-c-el-container">
                        <!-- <el-aside class="settings-aside" style="width:350px">
                            <div class="digi-sidebar digi-left-positioned digi-open digi-locked-open">
                                <div class="cover-card">
                                    <div class="cover-pic row ml-0 mr-0">
                                        <img class="cover-card-img-top w-full" :src="profile_data.cover_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg'"  alt="Cover Picture" style="height: 180px;" />
                                        <div class="pl-2 pt-1 pointer profile-background-upload">
                                            <label class="icon icon-picture text-white d-block fs-14 pr-1 w-100 pointer pl-1" style="line-height: 21px;">
                                                <input type="file" ref="myCoverPic"  accept="image/x-png, image/gif, image/jpeg"  @change="onUserBackground" />
                                                <span class="ml-2 text-white" style="font-family: 'Poppins', sans-serif !important;font-size: 12px;font-weight: normal;">Edit Photo</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="cover-card-block wall-person-info">
                                        <a class="person-avatar bg-white pro-img-bordered">
                                            <img class="profileImg" :src="profile_data.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :alt="profile_data.full_name" />
                                            <label class="profilePicEdit">
                                                <input type="file" ref="myProfilePic" accept="image/x-png, image/gif, image/jpeg" id="fileprofile" @change="onUserProfile" />
                                                <img src="/static/images/editgrey.svg" />
                                            </label>
                                        </a>
                                    </div>
                                </div>
                                <div class="digi-content-block px-4 py-2 mt-10">
                                    <div class="header pt-4">
                                        <div class="contactInfo">
                                            <div>
                                                <span class="text-white fw-600 fs-18 contactTitle">{{ profile_data.first_name.value }} {{ profile_data.last_name ? profile_data.last_name.value : '' }}</span>
                                                <div class="my-2 contactTitle">
                                                    <i class="crmnew-envelope mr-1 mb-1 text-white iconsize-14"></i>
                                                    <span>{{ profile_data.primary_email.value }}</span>
                                                </div>
                                                <div class="px-6" style="border-top: 1px solid #fff;">
                                                    <div v-if="account"
                                                        class="text-center text-white fw-600 fs-14 pt-4">
                                                        Business Profile</div>
                                                    <div v-else class="text-center text-white fw-600 fs-14 pt-4">
                                                        Personal
                                                        Profile</div>
                                                    <div class="text-center text-white fw-600 pt-4">
                                                        {{ loggedInUser.hasOwnProperty('company_details') ? loggedInUser.company_details.company_name : ''}}
                                                    </div>
                                                    <div class="widget widget6 card pt-3 pb-3 mt-5"
                                                        style="box-shadow: none;border-radius: 10px;border: solid 0.5px #1eabe5;background-color: #29c2e0;">
                                                        <div class="widget-content">
                                                            <div class="row no-gutters" style="cursor: pointer;">
                                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center" @click="goToConnections" style="border-bottom: 1px solid #1ca7e6;">
                                                                    <div class="connectionbox">
                                                                        <div class="connection_pic">
                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_small.svg"
                                                                                alt="Connetions" />
                                                                        </div>
                                                                        <div class="connection_details">
                                                                            <div class="count h2 text-white connection_text mb-1 ">
                                                                                 {{ connectionCount.connections_count || 0 }}
                                                                            </div>
                                                                            <div class="count-title text-white connection-title"> Connections</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center" @click="goToFollowers" style="border-bottom: 1px solid #1ca7e6;">
                                                                    <div class="connectionbox">
                                                                        <div class="connection_pic">
                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/followers_small.svg"  alt="Followers" />
                                                                        </div>
                                                                        <div class="connection_details">
                                                                            <div class="count h2 text-white mb-1 connection_text"> {{ connectionCount.followers_count || 0 }} </div>
                                                                            <div class="count-title text-white connection-title">= Followers</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center" @click="goToFollowing">
                                                                    <div class="connectionbox">
                                                                        <div class="connection_pic">
                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/following_small.svg" alt="Following" />
                                                                        </div>
                                                                        <div class="connection_details">
                                                                            <div class="count h2 text-white mb-1 connection_text"> {{ connectionCount.following_count || 0 }} </div>
                                                                            <div class="count-title text-white connection-title"> Following </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="qrcode-block-view mt-6">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/qr-logo-dg.svg" class="qr-logo-view" />
                                                    <qrcode-vue :value="valueqr" :size="size" level="H" background="#fff" foreground="#005dae" class="qrcode-content-view"></qrcode-vue>
                                                </div>
                                                <span class="text-white fw-600 fs-18 contactTitle mb-5 connection_text">Scan Code</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-aside> -->
                        <el-main class="contactTabs new-tab">
                            <!-- <div class=" d-flex search-report  w-100">
                                <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 8px 16px; height: 2.7em;"></i>
                                <input class="w-100" type="text"  placeholder="Search" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;">
                            </div> -->
                            <div class="settings-container mt-0 pt-3 pb-3 pl-3">
                                <div class="settings-left-sec display-menu">
                                    <ul class="settings-left-sec-list">
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center"  :class="{'activeOption':general_active}" @click="selectTab('general')">
                                            <img class="mr-3" :src="general_active ? '/static/images/images-new-theme/icons/home-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-setting.svg'" width="25px" height="25px" />General
                                        </li>
                                        <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':profile_active}" @click="selectTab('profile')">
                                            <img class="mr-3" :src="profile_active ? '/static/images/images-new-theme/icons/profile-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/profile-setting.svg'" width="25px" height="28px" /> Profile
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center"
                                            :class="{'activeOption':contact_active}" @click="selectTab('contact')">
                                            <img class="mr-3" :src="contact_active ? '/static/images/images-new-theme/icons/contacts-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/contact-setting.svg'" width="25px" height="28px" />Contacts
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':contact_active}"  @click="selectTab('contact')">
                                            <img class="mr-3" :src="contact_active ? '/static/icons/newicon/contacts-blue.png' : '/static/icons/newicon/contacts-gray.png'" width="25px" height="23px" />Contacts
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':company_active}" @click="selectTab('company')">
                                            <img class="mr-3" :src="company_active ? '/static/images/images-new-theme/icons/company-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/company-setting.svg'"  width="25px" height="28px" /> Companies
                                        </li>
                                        <li class="fw-600 fs-14 pointer  align-items-center" :class="{'activeOption':sales_active}" @click="selectTab('sales')">
                                            <img class="mr-3" :src="sales_active ? '/static/images/images-new-theme/icons/product-dark-blue.png' : '/static/icons/newicon/products-gray.png'"  width="25px" height="23px"/> Sales
                                            <i class="icon-chevron-right pl-20 mt-5 arrow" :class="{'activeOption':sales_active}" style="font-size: 30px;"></i>
                                        </li>-->
                                        <li v-if="userPermissions.company_profile.permitted_actions.view" class="fw-600 fs-14 pointer d-flex align-items-center"  :class="{'activeOption':company_profile_new}" @click="selectTab('about')">
                                            <img class="mr-3" :src="company_profile_new ? '/static/images/images-new-theme/icons/Page-1.png' : '/static/images/images-new-theme/icons/info-circle.png'" width="25px" height="25px" />About
                                        </li>
                                        <li class="fw-600 fs-14 pointer  align-items-center" :class="{'salesOption':leads_active || deals_active || territory_active || customer_active}" @click="subMenu()">
                                            <img class="mr-3" :src="leads_active || deals_active || territory_active || customer_active ? '/static/images/images-new-theme/icons/product-dark-blue.png' : '/static/icons/newicon/products-gray.png'"  width="25px" height="23px" style="margin-top: -5px;"/>Sales
                                            <i v-if="sub_menu" class="icon-chevron-down pl-22 arrow" :class="{'activeOption':leads_active || deals_active || territory_active || customer_active}" style="font-size: 25px;"></i>
                                            <i v-else class="icon-chevron-right pl-22 arrow" :class="{'activeOption':leads_active || deals_active || territory_active || customer_active}" style="font-size: 25px;"></i>
                                            <!-- <ul class="m-0 p-0 " >
                                                <li class="m-0" :class="{'activeOption':leads_active}">
                                                    <img class="mr-3" :src="leads_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                    <img class="mr-3" :src="leads_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Leads
                                                </li>
                                                <li class="m-0 " :class="{'activeOption':deals_active}" >
                                                    <img class="mr-3" :src="deals_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'" width="10px" height="13px" />
                                                    <img class="mr-3" :src="deals_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Deals
                                                </li>
                                                <li class="m-0" :class="{'activeOption':territory_active}" >
                                                    <img class="mr-3" :src="territory_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                    <img class="mr-3" :src="territory_active ? '/static/icons/newicon/territory-blue.png' : '/static/icons/newicon/territory-gray.png'"  width="25px" height="23px" />Territory
                                                </li>
                                                <li class="m-0" :class="{'activeOption':survey_active}" >
                                                    <img class="mr-3" :src="survey_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                    <img class="mr-3" :src="survey_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Survey Forms
                                                </li>
                                            </ul> -->

                                        </li>

                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item"  :class="{'activeOption':leads_active}" @click="selectTab('leads')"> <i class="icon-chevron-right arrow" :class="{'activeOption':leads_active}"  style="font-size: 25px;"></i>
                                            <img class="mr-3 ml-2" :src="leads_active ? '/static/images/images-new-theme/icons/leads_blue.svg' : '/static/images/images-new-theme/icons/leads_gray.svg'"  width="22px" height="25px" /><a> Leads</a>
                                        </li>
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':deals_active}" @click="selectTab('deals')"> <i class="icon-chevron-right arrow" :class="{'activeOption':deals_active}" style="font-size: 25px;"></i>
                                            <img class="mr-3 ml-2" :src="deals_active ? '/static/images/images-new-theme/icons/deals-blue.svg' : '/static/images/images-new-theme/icons/deal-gray.svg'"  width="22px" height="25px" /> <a>Deals</a>
                                        </li>
                                        <!-- <img class="mr-3" :src="territory_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" /> -->
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':territory_active}" @click="selectTab('territory')"> <i class="icon-chevron-right arrow" :class="{'activeOption':territory_active}" style="font-size: 25px;"></i>
                                            <img class="mr-3 ml-2" :src="territory_active ? '/static/icons/newicon/territory-blue.svg' : '/static/icons/newicon/territory-gray.svg'"  width="20px" height="23px" /><a>Territory</a>
                                        </li>
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':customer_active}" @click="selectTab('customer')"> <i class="icon-chevron-right arrow" :class="{'activeOption':customer_active}" style="font-size: 25px;"></i>
                                            <img class="mr-3 ml-2" :src="customer_active ? '/static/images/images-new-theme/icons/customer-blue.svg' : '/static/images/images-new-theme/icons/customer-icon-gray.svg'"  width="20px" height="23px" /><a>Customer</a>
                                        </li>

                                        <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':survey_forms_active}" @click="selectTab('survey_forms')">
                                            <img class="mr-3" :src="survey_forms_active ? '/static/images/images-new-theme/icons/survey-blue.svg' : '/static/images/images-new-theme/icons/survey-gray.svg'"  width="25px" height="28px" /> Survey Forms
                                        </li>
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':products_active}" @click="selectTab('products')">
                                            <img class="mr-3"  :src="products_active ? '/static/icons/newicon/sales-blue.png' : '/static/icons/newicon/sales-gray.png'" width="25px" height="23px" />Products
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':acess_mgmt_active}" @click="selectTab('access_mgmt')">
                                            <img class="mr-3" :src="acess_mgmt_active ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/access-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/access-setting-dark.svg'" width="25px" height="28px" /> Access Management
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':tools_active}" @click="selectTab('tools')">
                                            <img class="mr-3" :src="tools_active ? '/static/icons/newicon/tools-blue.png' : '/static/icons/newicon/tools-gray.png'"  width="25px" height="23px" /> Tools
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':reminder_active}" @click="selectTab('reminder')">
                                            <img class="mr-3" :src="reminder_active ? '/static/images/images-new-theme/icons/reminder_cal_blue.png' : '/static/images/images-new-theme/icons/reminder_cal_gray.svg'"  width="25px" height="23px" />Reminder
                                        </li> -->
                                        <li v-if="loggedInUser.user_role == 'sales_manager'" class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':tools_active}" @click="selectTab('user_permission')">
                                            <img class="mr-3" :src="tools_active ? '/static/icons/newicon/tools-blue.svg' : '/static/icons/newicon/tools-gray.svg'"  width="25px" height="23px" /> User Permission
                                        </li>
                                    </ul>
                                </div>
                                <div class="settings-left-sec display-menu-icons">
                                    <ul class="settings-left-sec-list">
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center"  :class="{'activeOption':general_active}" @click="selectTab('general')">
                                            <img class="mr-3" :src="general_active ? '/static/images/images-new-theme/icons/home-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-setting.svg'" width="25px" height="25px" />General
                                        </li>
                                        <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':profile_active}" @click="selectTab('profile')">
                                            <img class="mr-3" :src="profile_active ? '/static/images/images-new-theme/icons/profile-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/profile-setting.svg'" width="25px" height="28px" /> Profile
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center"
                                            :class="{'activeOption':contact_active}" @click="selectTab('contact')">
                                            <img class="mr-3" :src="contact_active ? '/static/images/images-new-theme/icons/contacts-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/contact-setting.svg'" width="25px" height="28px" />Contacts
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':contact_active}"  @click="selectTab('contact')">
                                            <img class="mr-3" :src="contact_active ? '/static/icons/newicon/contacts-blue.png' : '/static/icons/newicon/contacts-gray.png'" width="25px" height="23px" />Contacts
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':company_active}" @click="selectTab('company')">
                                            <img class="mr-3" :src="company_active ? '/static/images/images-new-theme/icons/company-setting-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/company-setting.svg'"  width="25px" height="28px" /> Companies
                                        </li>
                                        <li class="fw-600 fs-14 pointer  align-items-center" :class="{'activeOption':sales_active}" @click="selectTab('sales')">
                                            <img class="mr-3" :src="sales_active ? '/static/images/images-new-theme/icons/product-dark-blue.png' : '/static/icons/newicon/products-gray.png'"  width="25px" height="23px"/> Sales
                                            <i class="icon-chevron-right pl-20 mt-5 arrow" :class="{'activeOption':sales_active}" style="font-size: 30px;"></i>
                                        </li>-->
                                        <el-tooltip class="item" effect="dark" content="About" placement="right">
                                            <li v-if="userPermissions.company_profile.permitted_actions.view" class="fw-600 fs-14 pointer d-flex align-items-center"  :class="{'activeOption':company_profile_new}" @click="selectTab('about')">
                                                <img class="mr-3" :src="company_profile_new ? '/static/images/images-new-theme/icons/Page-1.png' : '/static/images/images-new-theme/icons/info-circle.png'" width="25px" height="25px" />
                                            </li>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="Sales" placement="right">
                                            <li class="fw-600 fs-14 pointer  align-items-center" :class="{'salesOption':leads_active || deals_active || territory_active || customer_active}" @click="subMenu()">
                                                <img class="mr-3" :src="leads_active || deals_active || territory_active || customer_active ? '/static/images/images-new-theme/icons/product-dark-blue.png' : '/static/icons/newicon/products-gray.png'"  width="25px" height="23px" style="margin-top: -5px;"/>
                                                <i v-if="sub_menu" class="icon-chevron-down arrow" :class="{'activeOption':leads_active || deals_active || territory_active || customer_active}" style="font-size: 25px;"></i>
                                                <i v-else class="icon-chevron-right arrow" :class="{'activeOption':leads_active || deals_active || territory_active || customer_active}" style="font-size: 25px;"></i>
                                                <!-- <ul class="m-0 p-0 " >
                                                    <li class="m-0" :class="{'activeOption':leads_active}">
                                                        <img class="mr-3" :src="leads_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                        <img class="mr-3" :src="leads_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Leads
                                                    </li>
                                                    <li class="m-0 " :class="{'activeOption':deals_active}" >
                                                        <img class="mr-3" :src="deals_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'" width="10px" height="13px" />
                                                        <img class="mr-3" :src="deals_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Deals
                                                    </li>
                                                    <li class="m-0" :class="{'activeOption':territory_active}" >
                                                        <img class="mr-3" :src="territory_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                        <img class="mr-3" :src="territory_active ? '/static/icons/newicon/territory-blue.png' : '/static/icons/newicon/territory-gray.png'"  width="25px" height="23px" />Territory
                                                    </li>
                                                    <li class="m-0" :class="{'activeOption':survey_active}" >
                                                        <img class="mr-3" :src="survey_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" />
                                                        <img class="mr-3" :src="survey_active ? '/static/icons/newicon/leads-blue.png' : '/static/icons/newicon/leads-gray.png'"  width="25px" height="23px" />Survey Forms
                                                    </li>
                                                </ul> -->

                                            </li>
                                        </el-tooltip>
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item"  :class="{'activeOption':leads_active}" @click="selectTab('leads')"> <i class="icon-chevron-right arrow" :class="{'activeOption':leads_active}"  style="font-size: 25px;"></i>
                                            <el-tooltip class="item" effect="dark" content="Leads" placement="right">
                                                <span><img class="mr-3 ml-2" :src="leads_active ? '/static/images/images-new-theme/icons/leads_blue.svg' : '/static/images/images-new-theme/icons/leads_gray.svg'"  width="22px" height="25px" /></span>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':deals_active}" @click="selectTab('deals')"> <i class="icon-chevron-right arrow" :class="{'activeOption':deals_active}" style="font-size: 25px;"></i>
                                            <el-tooltip class="item" effect="dark" content="Deals" placement="right">
                                                <span><img class="mr-3 ml-2" :src="deals_active ? '/static/images/images-new-theme/icons/deals-blue.svg' : '/static/images/images-new-theme/icons/deal-gray.svg'"  width="22px" height="25px" /></span>
                                            </el-tooltip>
                                        </li>
                                        <!-- <img class="mr-3" :src="territory_active ? '/static/icons/newicon/next-blue.png' : '/static/icons/newicon/next-gray.png'"  width="10px" height="13px" /> -->
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':territory_active}" @click="selectTab('territory')"> <i class="icon-chevron-right arrow" :class="{'activeOption':territory_active}" style="font-size: 25px;"></i>
                                            <el-tooltip class="item" effect="dark" content="Territory" placement="right">
                                                <span><img class="mr-3 ml-2" :src="territory_active ? '/static/icons/newicon/territory-blue.svg' : '/static/icons/newicon/territory-gray.svg'"  width="20px" height="23px" /></span>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="sub_menu" class="fw-600 fs-14 pointer d-flex align-items-center menu-item" :class="{'activeOption':customer_active}" @click="selectTab('customer')"> <i class="icon-chevron-right arrow" :class="{'activeOption':customer_active}" style="font-size: 25px;"></i>
                                            <el-tooltip class="item" effect="dark" content="Customer" placement="right">
                                                <span><img class="mr-3 ml-2" :src="customer_active ? '/static/images/images-new-theme/icons/customer-blue.svg' : '/static/images/images-new-theme/icons/customer-icon-gray.svg'"  width="20px" height="23px" /></span>
                                            </el-tooltip>
                                        </li>
                                        <el-tooltip class="item" effect="dark" content="Survey Forms" placement="right">
                                            <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':survey_forms_active}" @click="selectTab('survey_forms')">
                                                <img class="mr-3" :src="survey_forms_active ? '/static/images/images-new-theme/icons/survey-blue.svg' : '/static/images/images-new-theme/icons/survey-gray.svg'"  width="25px" height="28px" />
                                            </li>
                                        </el-tooltip>
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':products_active}" @click="selectTab('products')">
                                            <img class="mr-3"  :src="products_active ? '/static/icons/newicon/sales-blue.png' : '/static/icons/newicon/sales-gray.png'" width="25px" height="23px" />Products
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':acess_mgmt_active}" @click="selectTab('access_mgmt')">
                                            <img class="mr-3" :src="acess_mgmt_active ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/access-blue.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/access-setting-dark.svg'" width="25px" height="28px" /> Access Management
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':tools_active}" @click="selectTab('tools')">
                                            <img class="mr-3" :src="tools_active ? '/static/icons/newicon/tools-blue.png' : '/static/icons/newicon/tools-gray.png'"  width="25px" height="23px" /> Tools
                                        </li> -->
                                        <!-- <li class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':reminder_active}" @click="selectTab('reminder')">
                                            <img class="mr-3" :src="reminder_active ? '/static/images/images-new-theme/icons/reminder_cal_blue.png' : '/static/images/images-new-theme/icons/reminder_cal_gray.svg'"  width="25px" height="23px" />Reminder
                                        </li> -->
                                        <el-tooltip class="item" effect="dark" content="User Permission" placement="right">
                                            <li v-if="loggedInUser.user_role == 'sales_manager'" class="fw-600 fs-14 pointer d-flex align-items-center" :class="{'activeOption':tools_active}" @click="selectTab('user_permission')">
                                                <img class="mr-3" :src="tools_active ? '/static/icons/newicon/tools-blue.svg' : '/static/icons/newicon/tools-gray.svg'"  width="25px" height="23px" />
                                            </li>
                                        </el-tooltip>
                                    </ul>
                                </div>
                                <company-profile-new v-if="company_profile_new"></company-profile-new>
                                <sales v-if="sales_active"></sales>
                                <survey-settings v-if="survey_forms_active"></survey-settings>
                                <!-- <deals-settings v-if="deals_active"></deals-settings> -->
                                <select-deal-setting v-if="deals_active"></select-deal-setting>
                                <territory-settings v-if="territory_active"></territory-settings>
                                <!-- <leads-settings v-if="leads_active"></leads-settings> -->
                                <select-lead-setting v-if="leads_active"></select-lead-setting>
                                <reminder-settings v-if="reminder_active"></reminder-settings>
                                <!-- <addtional-details v-if="customer_active"></addtional-details> -->
                                <additional-info :selected_module="'customers'" v-if="customer_active"></additional-info>
                            </div>
                        </el-main>
                    </el-container>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { User } from "../mixins/user";
    import Leads from "../mixins/leads";
    // const Sales = () => import("./Sales.vue");
    const SurveySettings = () => import("./SurveySettings");
    import AdditionalInfo from './AdditionalInfo.vue'
    // const DealsSettings = () => import('./DealsSettings.vue');
    const TerritorySettings = () => import('./TerritorySettings')
    const ReminderSettings = () => import('./ReminderSettings')
    // const LeadsSettings = () => import('./LeadsSettings')
    const SelectDealSetting = () => import('./SelectDealSetting')
    const SelectLeadSetting = () => import('./SelectLeadSetting')
    import { HalfCircleSpinner } from "epic-spinners";
    import QrcodeVue from "qrcode.vue";
    const CompanyProfileNew = () =>  import('../CompanyProfileNew')
    export default {
        mixins: [User, Leads],
        data() {
            return {
                leads_title: '',
                account: '',
                ajax_call_in_progress: false,
                title: '',
                social_media: '',
                meeting_type: '',
                industry_type: '',
                lead_contact: '',
                campgain: '',
                salesTab: false,
                load_settings: false,
                ajaxCallinprogress: false,
                activateEditMode: false,
                campgain_options: [],
                connectionCount: "",
                valueqr: "https://example.com",
                size: 90,
                selected: "Leads",
                requestType: "",
                hover: "",
                active_tab: 'general',
                general: false,
                profile: false,
                companies: false,
                sales: false,
                survey_forms: false,
                contacts: false,
                products: false,
                access_mgmt: false,
                TitleTab: true,
                CampaginTab: false,
                industryTab: false,
                contactTab: false,
                general_active: false,
                company_active: false,
                acess_mgmt_active: false,
                profile_active: false,
                contact_active: false,
                sales_active: false,
                survey_forms_active: false,
                deals_active: false,
                leads_active: false,
                call_reports_active: false,
                sales_forecast_active: false,
                campagins_active: false,
                cutomer_active: false,
                territory_active:false,
                reminder_active:false,
                customer_active: false,
                survey_active:false,
                contract_active: false,
                access_mgmt_active: false,
                products_active: false,
                tools_active: false,
                subSalesModule:false,
                sub_menu:false,
                open_sub_menu:true,
                company_profile_new:true,
            }
        },
        components: {
            HalfCircleSpinner,
            QrcodeVue,
            // Sales,
            SurveySettings,
            // DealsSettings,
            TerritorySettings,
            ReminderSettings,
            SelectDealSetting,
            AdditionalInfo,
            CompanyProfileNew,
            // LeadsSettings,
            SelectLeadSetting
        },
        methods: {
            subMenu(){
                if(this.open_sub_menu == false){
                    this.sub_menu = false;
                    this.open_sub_menu = true;
                }else{
                    this.sub_menu = true;
                    this.open_sub_menu = false;
                }
            },
            goBack() {
                this.sales_active = true;
                this.contact_active = false;
                this.survey_forms_active = false;
                this.deals_active = false;
                this.leads_active = false;
                this.territory_active = false;
                this.reminder_active = false;
                this.customer_active =false;
                this.access_mgmt_active = false;
            },
            changeView(value) {
                if (value == 'general') {
                    this.general = true
                    this.profile = false
                    this.contacts = false
                    this.companies = false
                    this.sales = false
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = false
                } else if (value == 'profile') {
                    this.general = false
                    this.profile = true
                    this.contacts = false
                    this.companies = false
                    this.sales = false
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = false
                } else if (value == 'contacts') {
                    this.general = false
                    this.profile = false
                    this.contacts = true
                    this.companies = false
                    this.sales = false
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = false
                } else if (value == 'companies') {
                    this.general = false
                    this.profile = false
                    this.contacts = false
                    this.companies = true
                    this.sales = false
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = false
                } else if (value == 'sales') {
                    this.general = false
                    this.profile = false
                    this.contacts = false
                    this.companies = false
                    this.sales = true
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = false
                } else if (value == 'products') {
                    this.general = false
                    this.profile = false
                    this.contacts = false
                    this.companies = false
                    this.sales = false
                    // this.survey_forms = false
                    this.products = true
                    this.access_mgmt = false
                } else {
                    this.general = false
                    this.profile = false
                    this.contacts = false
                    this.companies = false
                    this.sales = false
                    // this.survey_forms = false
                    this.products = false
                    this.access_mgmt = true
                }

            },
            showSubMenu(){
                this.subSalesModule =true
            },
            // Change Password Modal
            changePassword() {
                this.$modal.show("change_password_modal");
            },
            passwordChanged() {
                this.$modal.show("password_changed_modal");
            },
            updateSettings() {
                // if (this.contacts == true) {
                //     this.activateEditMode = !this.activateEditMode;
                //     EventBus.$emit("saveContactSettingnew");
                //     EventBus.$emit("updateContactSettings");
                // } else if (this.sales == true) {
                //     EventBus.$emit("saveSalesSettings");
                //     EventBus.$emit("updateSalesSettings");
                //     this.activateEditMode = !this.activateEditMode;
                // } else {
                //     this.activateEditMode = !this.activateEditMode;
                // }
            },
            selectTab(tab) {
                if (tab == 'general') {
                    this.general_active = true;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'profile') {
                    this.general_active = false;
                    this.contact_active = false;
                    this.sales =false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false
                    this.profile_active = true;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'contact') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.sales =false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false
                    this.contact_active = true;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'sales') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.sales =false;
                    this.contact_active = false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false
                    this.sales_active = true;
                    this.survey_forms_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.deals_active = false;
                    this.salesTab = true;
                    this.leads_active = false;
                    this.company_profile_new = false;
                }
                else if (tab == 'survey_forms') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = true;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                }
                else if (tab == 'access_mgmt') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false
                    this.access_mgmt_active = true;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'products') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.sales =false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = true;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'tools') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.sales =false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.sales =false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = true;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'company') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales =false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = true;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'deals') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.sales =false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = true;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'leads') {
                    this.general_active = false;
                    this.profile_active = false;
                    this.sales =false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.leads_active = true;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false
                    this.company_profile_new = false;
                }
                 else if (tab == 'territory'){
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = true;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'customer'){
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =true;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                } else if (tab == 'reminder'){
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = true;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = false;
                }else if (tab == 'about'){
                    this.general_active = false;
                    this.profile_active = false;
                    this.contact_active = false;
                    this.sales_active = false;
                    this.sales =false;
                    this.survey_forms_active = false;
                    this.deals_active = false;
                    this.territory_active = false;
                    this.reminder_active = false;
                    this.customer_active =false;
                    this.access_mgmt_active = false;
                    this.products_active = false;
                    this.company_active = false;
                    this.tools_active = false;
                    this.leads_active = false;
                    this.company_profile_new = true;
                    } else if (tab == 'user_permission'){
                    this.$router.push('/settingComponents/user_permission')
                }
            },
            // Cover Picture Change Function
            onUserBackground(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURLprofile(input.files[0], attachment, "cover_pic");
                }
            },
            // User Profile Image Change Function
            onUserProfile(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURLprofile(input.files[0], attachment, "profile_pic");
                }
            },
            getResumableURLprofile(file, attachment, type) {
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http.post("https://cloudapis.digicollect.com/external/upload_file", data).then(response => {
                    if (response.data.status_id == 1) {
                        this.saveEditImage(type, response.data.url);
                    }
                }).catch(error => {
                    // this.error = "Error Uploading"
                });
            },
            goToConnections() {
                var request_type = null;
                if (this.account) {
                    request_type = "business";
                } else {
                    request_type = "personal";
                }
                var id = this.loggedInUser.id;
                this.$router.push({
                    name: "ConnectionList",
                    params: {
                        id: id,
                        request_type: request_type,
                    },
                });
            },
            goToFollowers() {
                this.$router.push({
                    name: "FollowerList"
                });
            },
            goToFollowing() {
                this.$router.push({
                    name: "FollowingList"
                });
            },
            // Asynchronous Get Connection API
            async getConnectionsCount() {
                // let res = await this.$http.get("/connections/connection_count?id=" + this.loggedInUser.id);
                // if (res.data.status_id == 1) {
                //     this.connectionCount = res.data.response;
                // }
            },
        },
        mounted() {
            setTimeout(() => {
                if(this.$route.query.deals_active){
                    this.changeView('sales');
                    this.selectTab('deals');
                    this.sub_menu = true;
                }
                if(this.$route.query.territory) {
                    this.changeView('sales');
                    this.selectTab('territory');
                    this.sub_menu = true;
                }
                if(this.$route.query.leads) {
                    this.changeView('sales');
                    this.selectTab('leads');
                    this.sub_menu = true;
                }
            }, 1000);
            //this.getRequestType();
            // this.GetUserData(this.loggedInUser.id);
            // this.getConnectionStatus({
            //     user_id: this.loggedInUser.id,
            //     request_type: this.requestType,
            // });
            // this.getConnectionsCount();
            $(document).ready(function(){
                $('.menu-item > a').click(function(e){
                    e.preventDefault();
                    $(this).next('.sub-menu').slideToggle();
                });
            });
            if(this.userPermissions.company_profile.permitted_actions.view){
                this.company_profile_new = true;
                this.selectTab('about');
            } else {
                this.company_profile_new = false;
                this.leads_active = true;
                this.open_sub_menu = false;
                this.sub_menu = true;
                this.selectTab('leads');
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            }
        },

    }
</script>
<style scoped>
    /* .activeTab{
      width: 0;
      height: 0;
      border-bottom: 40px solid #f2f3f5;
      border-right: 25px solid transparent;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      margin-left: -2px;
    } */
    .fields-data {
        background: #ffffff;
        border-radius: 1px !important;
        margin-top: 10px
    }
    .settings-aside {
        /* background-image: linear-gradient(to top, #0b54cf, #1785ff);
        background-size: cover;
        background-repeat: no-repeat; */
        background-color: #2b6ad0;
        height: auto;
        border-radius: 8px !important;
    }
    .settings-container {
        padding: 0.4px 0.2px 0px 0;
        border-radius: 6px;
        background-color: #fff;
        min-height: 49em;
        height: 100%;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        width: 100%;
        min-width: 100%;
        /* overflow-x: auto;
        overflow-y: hidden; */
    }
    .settings-left-sec-list {
        padding-top: 5px;
        padding-left: 0;
    }
    .settings-left-sec-list li {
        list-style: none;
        margin: 10px 0;
        padding: 8px 20px;
        border-radius: 2.5px;
        letter-spacing: 0.43px;
        color: #3f3f3f;
    }
    .settings-left-sec-list li.activeOption {
        color: #00448b;
        background-color: #ecf1f9;
    }
    .settings-left-sec-list li.salesOption {
        color: #00448b;
        background-color: #fff;
    }
    .create-settings-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-settings-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .connection_text {
        line-height: 1.19;
        font-size: 16px;
    }
    .connection-title {
        line-height: 1.19;
        font-size: 14px;
        font-weight: 600;
    }
    .el-main.contactTabs{
        overflow: hidden;
    }
    .fw-600 fs-14 pointer d-flex align-items-center .dropdown-menu {
        margin-top: -4px !important;
        margin-left: 5px !important;
        margin-right: 0px;
        top: 0px !important;
        left: 100%;
    }
    .fw-600 fs-14 pointer d-flex align-items-center {
        position: relative;
    }
    .dropdown-menu.dropdown-width li a {
        height: 38px !important;
        color: rgb(48, 48, 49) !important;
        line-height: 38px !important;
        background: transparent;
        font-weight: 500;
        font-family: "Poppins" !important;
    }
    .dropdown-menu.dropdown-width .dropdown-toggle.togglePlace::after {
        position: relative;
        top: 13px;
        float: right;
    }
    .dropdown-menu.dropdown-width li a:hover {
        background-color: #ecf1f9 !important;
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width li a i{
        visibility: hidden;
    }
    .dropdown-menu.dropdown-width li a:hover i{
        visibility: visible !important;
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width .closeMenu a:hover{
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width {
        min-width: 14rem !important;
        margin: 0.25rem 0rem 0 !important;
    }
    .dropdown-menu.show {
        display: block;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        transition-property: color, background-color, opacity !important;
    }
    .dc-menu li {
        list-style: none;
    }
    a.dropdown-item.nav-link {
        padding: 0px 24px 0px 10px;
    }
    .dc-menu-item .dropdown-toggle::after {
        margin-top: 4px !important;
        margin-left: 10px !important;
    }
    .navelements {
        opacity: 0;
        transition: opacity .5s linear;
    }
    .toggle:checked+#navelements {
        opacity: 1;
    }
    .toggle {
        display: none;
    }
    .arrow.activeOption {
        color: #00448b;
    }
    .settings-left-sec ul ul {
        position: relative;
        display: none;
    }
    .settings-left-sec ul li:hover>ul {
        display: block;
    }
    .submenu {
        position: relative;
        display: none;
    }
    .info-circle-color{
        color: #00448b !important;
    }
    @media (max-width: 991px){
        .display-menu{
            display: none !important;
        }
        .settings-left-sec {
            display: -webkit-box;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
            -webkit-box-flex: 1;
            flex: 1 0 auto;
            overflow-x: hidden;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            width: 110px !important;
            min-width: 110px !important;
            max-width: 110px !important;
            box-shadow: 0 0 10px 0 #eaeaea;
        }
    }
    @media (min-width: 992px){
        .display-menu-icons{
            display: none !important;
        }
        .settings-left-sec {
            display: -webkit-box;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
            -webkit-box-flex: 1;
            flex: 1 0 auto;
            overflow-x: hidden;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            width: 250px !important;
            min-width: 250px !important;
            max-width: 250px !important;
            box-shadow: 0 0 10px 0 #eaeaea;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SettingsComponents/Settings.vue